import { render, staticRenderFns } from "./shipment_set.vue?vue&type=template&id=c47c7e5c"
import script from "./shipment_set.vue?vue&type=script&lang=js"
export * from "./shipment_set.vue?vue&type=script&lang=js"
import style0 from "./shipment_set.vue?vue&type=style&index=0&id=c47c7e5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports